export interface CommunicatorConfig {
  publishKey: string;
  subscribeKey: string;
  uuid: string;
  cfsUuid?: string;
}
